export default "__VITE_ASSET__BStvh3e___"